import React from 'react';

const StatusBadge = ({ status }) => {
    const styles = {
        success: 'bg-emerald-100 text-emerald-700',
        pending: 'bg-amber-100 text-amber-700',
        cancelled: 'bg-slate-100 text-slate-600',
        error: 'bg-rose-100 text-rose-700',
        approved: 'bg-emerald-100 text-emerald-700',
        rejected: 'bg-rose-100 text-rose-700',
        accepted: 'bg-emerald-100 text-emerald-700',
        manual_review: 'bg-amber-100 text-amber-700',
    };
    const labels = {
        success: 'Оплачено',
        pending: 'Ожидание',
        cancelled: 'Отменён',
        error: 'Ошибка',
        approved: 'Одобрено',
        rejected: 'Отклонено',
        accepted: 'Принят',
        manual_review: 'На проверке',
    };
    return (
        <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold ${styles[status] || 'bg-gray-100 text-gray-600'}`}>
            {labels[status] || status}
        </span>
    );
};

export default StatusBadge;